/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CardCampaign.scss';
import {
  appButtonType,
  appIconsPath,
  appLinkSize,
  appLinkStyle,
  appCardStyle,
  cardRedirectionType
} from '@utils/globalConstant';
import { Link } from '@core/Link';
import { ButtonClose } from '@core/ButtonClose';
import { ButtonPrimary } from '@core/ButtonPrimary';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import PropTypes from 'prop-types';

export function CardCampaign({
  cardStyle = appCardStyle.DEFAULT_GRADIENT,
  image = null,
  headline = 'Headline',
  desc = 'Description',
  handleClose = () => {},
  redirectionType = cardRedirectionType.LINK,
  redirectionLabel = 'Link',
  handleRedirection = redirectionType === cardRedirectionType.LINK ? '#' : () => {}
}) {
  return (
    <>
      <div className={`${cardStyle} card w-100 rounded-4 position-relative p-0`}>
        <div className="position-absolute top-0 end-0 pt-16 pe-16">
          <ButtonClose
            isLightBtn={cardStyle === appCardStyle.PRIMARY_GRADIENT}
            onClick={handleClose}
          />
        </div>

        {image && (
          <img
            src={image}
            className="card-img-top rounded-top-4 img-fluid object-fit-cover"
            alt="campaign-card"
            style={{ maxHeight: '128px' }}
          />
        )}

        <div className="card-header p-16 pb-0 border-0 bg-transparent">
          <div className="d-flex justify-content-between">
            <h5 className="card-title ek-copy-16-semibold m-0 pe-28">{headline}</h5>
          </div>
        </div>

        <div className="card-body px-16 py-12">
          <div
            className="card-text ek-copy-sm-14-regular"
            dangerouslySetInnerHTML={{ __html: sanitizeRichText(desc) }}
          />
        </div>

        <div className="card-footer p-16 pt-0 border-0 bg-transparent">
          {redirectionType === cardRedirectionType.LINK && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
              label={redirectionLabel}
              iconRight={appIconsPath.ARROW_RIGHT_SMALL}
              linkStyle={
                cardStyle === appCardStyle.DEFAULT_GRADIENT
                  ? appLinkStyle.PRIMARY
                  : appLinkStyle.SECONDARY
              }
              linkSize={appLinkSize.LARGE}
              linkRef={handleRedirection}
            />
          )}
          {redirectionType === cardRedirectionType.BUTTON && (
            <ButtonPrimary
              label={redirectionLabel}
              buttonType={
                cardStyle === appCardStyle.DEFAULT_GRADIENT
                  ? appButtonType.PRIMARY
                  : appButtonType.SECONDARY
              }
              onClick={handleRedirection}
            />
          )}
        </div>
      </div>
    </>
  );
}

CardCampaign.propTypes = {
  cardStyle: PropTypes.string,
  image: PropTypes.string,
  headline: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  redirectionType: PropTypes.string,
  redirectionLabel: PropTypes.string.isRequired,
  handleRedirection: PropTypes.func.isRequired
};

export default CardCampaign;
